import React from 'react';
import { haptic } from '../../utils/haptics';
import styles from './agentChat.module.css';

const SIGN = { ILS: '₪', USD: '$', EUR: '€', GBP: '£' };

/**
 * THE PLACES FOR RENT THE AGENT NAMED (owner 10-23: "book stay from date X to Y"). Each shows the place, its size and
 * its price from a night; the card opens the place's page (`onOpen`), "Book a stay" starts a stay request in the
 * conversation (`onBook` → the server's `stay_start`: dates, guests, then the quote before any price is said), and the
 * quiet "?" asks about it.
 */
export default function StayStrip({ stays, currency = 'ILS', hrefFor, onOpen, onBook, onAsk, busy = false, t }) {
  if (!stays?.length) return null;
  const sign = SIGN[currency] ?? '';
  return (
    <div className={styles.strip} role="list" data-testid="agent-stay-strip">
      {stays.map((s) => {
        const size = [
          s.bedrooms ? t('agent.bedrooms', { defaultValue: '{{count}} bedrooms', count: s.bedrooms }) : '',
          s.maxGuests ? t('agent.upToGuests', { defaultValue: 'up to {{count}} guests', count: s.maxGuests }) : '',
        ].filter(Boolean).join(' · ');
        const href = hrefFor ? hrefFor(s.slug) : undefined;
        return (
          <div key={s.slug} role="listitem" className={`${styles.card} ${styles.offerCard}`}>
            <a className={styles.cardOpen} href={href} onClick={(e) => { if (onOpen && href) { e.preventDefault(); onOpen(href); } }}>
              {s.image ? <div className={styles.cardImage}><img src={s.image} alt={s.name} loading="lazy" /></div> : null}
              <div className={styles.offerBody}>
                <div className={styles.cardName}>{s.name}</div>
                {size ? <div className={styles.offerMeta}>{size}</div> : null}
                {typeof s.fromNight === 'number' ? <div className={styles.cardPrice}><span>{t('agent.fromNight', { defaultValue: 'from {{price}} a night', price: `${sign}${s.fromNight.toLocaleString('en-US')}` })}</span></div> : null}
              </div>
            </a>
            <div className={styles.cardActions}>
              {onBook ? <button type="button" className={styles.cardAction} disabled={busy} onClick={() => onBook(s)}>{t('agent.bookStay', { defaultValue: 'Book a stay' })}</button> : null}
              {onAsk ? (
                <button type="button" className={styles.askAbout} aria-label={t('agent.askAboutThis', { defaultValue: 'Ask about this' })} title={t('agent.askAboutThis', { defaultValue: 'Ask about this' })} onClick={() => { haptic('selection'); onAsk(s); }}>
                  <span aria-hidden="true">?</span>
                </button>
              ) : null}
            </div>
          </div>
        );
      })}
    </div>
  );
}
